const AutotaskUsersMappings = () => import('@/views/account/integrations/autotask/mappings/autotask-users-mappings-view.vue');
const AutotaskCompaniesMappings = () => import('@/views/account/integrations/autotask/mappings/autotask-companies-mappings-view.vue');
const AutotaskActivitiesMappings = () => import('@/views/account/integrations/autotask/mappings/autotask-activities-mappings-view');
const AutotaskOpportunitiesMappings = () => import('@/views/account/integrations/autotask/mappings/autotask-opportunities-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Autotask/Manage/Users/Mappings',
        name: 'AutotaskUsersMappings',
        component: AutotaskUsersMappings,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Users/Mappings',
        name: 'ClientAutotaskUsersMappings',
        component: AutotaskUsersMappings,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Companies/Mappings',
        name: 'AutotaskCompaniesMappings',
        component: AutotaskCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Companies/Mappings',
        name: 'ClientAutotaskCompaniesMappings',
        component: AutotaskCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Activities/Mappings',
        name: 'AutotaskAutotaskActivitiesMappings',
        component: AutotaskActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Activities/Mappings',
        name: 'ClientAutotaskActivitiesMappings',
        component: AutotaskActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Autotask/Manage/Opportunities/Mappings',
        name: 'AutotaskOpportunitiesMappings',
        component: AutotaskOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Autotask/Manage/Opportunities/Mappings',
        name: 'ClientAutotaskOpportunitiesMappings',
        component: AutotaskOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]